class VideoWalkthrough extends HTMLElement {
  connectedCallback() {
    this.trigger = this.querySelector('[data-vw-open]');
    this.modal = this.querySelector('[data-vw-modal]');
    if (!this.trigger || !this.modal) return;

    this.closers = this.modal.querySelectorAll('[data-vw-close]');
    this.video = this.modal.querySelector('[data-vw-video]');
    this.iframe = this.modal.querySelector('[data-vw-iframe]');

    this.onKeydown = this.onKeydown.bind(this);

    this.trigger.addEventListener('click', () => this.open());
    this.closers.forEach((el) => el.addEventListener('click', () => this.close()));
  }

  open() {
    this.modal.hidden = false;
    document.body.style.overflow = 'hidden';
    document.addEventListener('keydown', this.onKeydown);

    if (this.iframe && this.iframe.dataset.src) {
      this.iframe.src = this.iframe.dataset.src;
    }
    if (this.video) {
      try {
        this.video.play();
      } catch (e) {}
    }

    const focusTarget = this.modal.querySelector('.vw-modal__close');
    focusTarget?.focus();
  }

  close() {
    this.modal.hidden = true;
    document.body.style.overflow = '';
    document.removeEventListener('keydown', this.onKeydown);

    if (this.iframe) {
      this.iframe.src = 'about:blank';
    }
    if (this.video) {
      this.video.pause();
      this.video.currentTime = 0;
    }

    this.trigger.focus();
  }

  onKeydown(event) {
    if (event.key === 'Escape') {
      this.close();
      return;
    }
    // Trap Tab focus inside the open dialog (WCAG 2.4.3). Once focus enters a
    // cross-origin video iframe the browser owns tabbing within it; we can only
    // guard the boundary (close button <-> last control), which is standard.
    if (event.key !== 'Tab') return;
    const focusable = this.modal.querySelectorAll(
      'button, [href], iframe, video, input, select, textarea, [tabindex]:not([tabindex="-1"])',
    );
    if (!focusable.length) return;
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }
}

if (!customElements.get('video-walkthrough')) {
  customElements.define('video-walkthrough', VideoWalkthrough);
}
